<div id="pcoded" class="pcoded">
    <div class="pcoded-overlay-box"></div>
    <div class="pcoded-container navbar-wrapper">
        <app-navbar></app-navbar>
        <div class="pcoded-main-container">
            <div class="pcoded-wrapper">
                <app-sidebar></app-sidebar>
                <div class="pcoded-content">
                    <div class="pcoded-inner-content">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>